import { useTranslation } from 'react-i18next';
import config from '@core/config';

// One tone per environment that is not production, each a different colour so the two are
// never confused with each other or with the real thing.
const ENVIRONMENTS: Record<string, { tone: string; label: string }> = {
  staging: {
    tone: 'bg-[var(--color-warning-subtle)] border-[var(--color-warning)]/20 text-[var(--color-warning)]',
    label: 'app.stagingBanner',
  },
  local: {
    tone: 'bg-[var(--color-accent-subtle)] border-[var(--color-accent)]/20 text-[var(--color-accent)]',
    label: 'app.localBanner',
  },
};

/**
 * A thin strip across the top of every page of a build that is not production: yellow on
 * staging, teal on a local development run. Nothing renders in production. The build sets
 * the environment through `VITE_ENV` (see the Dockerfile and CI), read here as
 * `config.env`; it falls back to `local` when unset.
 */
export function EnvironmentBanner() {
  const { t } = useTranslation();
  const environment = ENVIRONMENTS[config.env];

  if (!environment) return null;

  return (
    <div
      role="status"
      className={`flex h-6 items-center justify-center border-b px-4 text-xs font-medium ${environment.tone}`}
    >
      {t(environment.label)}
    </div>
  );
}
